import { Popover, Spin } from 'antd';
import { More, SpinContainer, Spu, SpuList } from '@knowledge/common/components/SpuBasic';
import { EllipsisOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { getItemsByInternalIds } from '@knowledge/common/cache/spu';

function SpuMore(props: { children: React.ReactNode; spus: Knowledge.SingleClass.Value['spus'] }) {
  const { children, spus } = props;
  const {
    data: spuList,
    loading,
    refresh,
  } = useRequest(() => getItemsByInternalIds(spus), {
    manual: true,
  });
  return (
    <Popover
      trigger="hover"
      placement="topLeft"
      onVisibleChange={(visible) => {
        visible && refresh();
      }}
      content={
        <SpuList>
          {loading ? (
            <SpinContainer>
              <Spin />
            </SpinContainer>
          ) : (
            spuList?.map((spu) => {
              const { itemName, imageUrl: [imageUrl] = [], skuInfo = [] } = spu;
              const newSpu: any = {};
              newSpu.imageUrl = imageUrl;
              newSpu.skus = skuInfo;
              newSpu.title = itemName;
              return (
                <li key={spu.internalItemId}>
                  <Spu spu={newSpu} />
                </li>
              );
            })
          )}
        </SpuList>
      }
    >
      <More>
        {children}
        <span>
          <EllipsisOutlined />
        </span>
      </More>
    </Popover>
  );
}

export default SpuMore;
